module.exports = __webpack_public_path__ + "img/kachel-HERZKREISLAUF-CISTUSTEE.8498cff3.png";